import Ring from "./Ring.react"

const content = { Ring }
export default content
